export enum PERM_CODES {
  REPORTS_DAILY_EXCEL_OLD = 'PMS0002', // 营业日报-旧版EXCEL报表按钮权限
  GUEST_RUNNING_ACCOUNT = 'PMS0003', // 宾客详情-会员流水TAB权限
  REALTIME_LOCK_ROOM = 'PMS0005', // 实时房态-停用原因锁房选项
  CANCEL_XC_ZL_RESERVE = 'PMS0004', // 取消携程直连预订订单
  CHECKIN_HISTORY = 'PMS0007', // 宾客详情-入住记录TAB权限
  MEMBER_CARD_ACROSS_NIGHT_REFUND = 'PMS0008', // PMS-订单-会员卡-退款-跨夜审退款退卡权限
  MEMBER_CARD_ONLY_BACK_CARD = 'PMS0009', // PMS-订单-会员卡-退款-不退款仅退卡权限
  MEMBER_RECHARGE_ACROSS_NIGHT_REFUND = 'PMS0010', // PMS-订单-会员充值-退款-跨夜审退款权限
  FRONT_CROSS_NIGHT_AUDIT_REFUND = 'PMS0006', // PMS-订单-前台业务订单-退款弹框--跨夜审退款权限
  FRONT_GOODS_CROSS_NIGHT_AUDIT_REFUND = 'PMS0013', // PMS-订单-前台商品订单-退款弹框--跨夜审退款权限
  GUEST_PLAINTEXT_INFO_QUERY = 'PMS0014', // 宾客手机号、证件号明文查询
  MOMENT_TEMPLATE_EDIT = 'PMS0011', // 微信朋友圈模板编辑
  ROLE_FOR_ADMIN_REGION = 'PMS0016', // 管理员、区域经理 角色权限
  ROLE_FOR_ADMIN_REGION_OWNER = 'PMS0015', // 管理员、区域经理、店长 角色权限
  SYSTEM_ACCOUNT_OWNER_GROUP = 'PMS0018', // 系统账号店长组
  CRS_STORE_INFO = 'PMS0022', // CRS门店信息权限
  CRS_ROOM_TYPE_INFO = 'PMS0023', // CRS房型信息权限
  UPDATE_PRICE_PASS = 'PMS0019', // PMS集团-改价审批页面，“通过”按钮: 区域经理、战区负责人、电酒营运部负责人、电酒营运中台负责人、系统管理员
  UPDATE_PRICE_RETURN = 'PMS0020', // PMS集团-改价审批页面，“退回”按钮: 区域经理、战区负责人、电酒营运部负责人、电酒营运中台负责人、系统管理员
  UPDATE_PRICE_WITHDRAW = 'PMS0021', // PMS门店-改价审批页面，“撤回”按钮，: 前厅、值班经理、盟友、店长、门店负责人、区域经理、战区负责人、电酒营运部负责人、电酒营运中台负责人、系统管理员
  SELF_SERVICE_CROSS_NIGHT_AUDIT_REFUND = 'PMS0025', // 自助点餐订单跨夜审退款权限
  CRS_MANAGE_INVITATION = 'PMS0031', // CRS邀请单

  CASHFLOW_APPLY_REGION_SUBMIT = 'PMS0040', // 提交区域审批
  CASHFLOW_APPLY_WITHDRAW = 'PMS0041', // 撤回审批
  CASHFLOW_APPLY_REGION_PASS = 'PMS0042', // 区域审批通过
  CASHFLOW_APPLY_REGION_REJECT = 'PMS0043', // 区域审批退回
  CASHFLOW_APPLY_ALLY_PASS = 'PMS0044', // 盟友审批通过
  CASHFLOW_APPLY_ALLY_REJECT = 'PMS0045', // 盟友审批退回
  GROUP_CASHFLOW_APPLY_REGION_SUBMIT = 'PMS0046', // 集团提交区域审批
  GROUP_CASHFLOW_APPLY_WITHDRAW = 'PMS0047', // 集团撤回审批
  GROUP_CASHFLOW_APPLY_REGION_PASS = 'PMS0048', // 集团区域审批通过
  GROUP_CASHFLOW_APPLY_REGION_REJECT = 'PMS0049', // 集团区域审批退回
  GROUP_CASHFLOW_APPLY_ALLY_PASS = 'PMS0050', // 集团盟友审批通过
  GROUP_CASHFLOW_APPLY_ALLY_REJECT = 'PMS0051', // 集团盟友审批退回

  SCHEDULE_TAB = 'PMS0032', // PMS门店排班权限
  CRS_ROOM_NUMS_INFO = 'PMS0028', // CRS房量管理权限
  CRS_PRODUCT_INFO = 'PMS0029', // CRS产品信息权限
  CRS_CHANNEL_INFO = 'PMS0030', // CRS渠道信息权限,

  // 订单房间页按钮
  RESERVE_AGAIN = 'PMS0100',
  CHECKIN_AGAIN = 'PMS0101',
  JOIN_UNITE_ROOM = 'PMS0102',
  RESERVE_2_CHECKIN = 'PMS0103',
  RESERVE_EDIT = 'PMS0104',
  RESERVE_CANCEL = 'PMS0105',
  EXTEDN_CHECKIN = 'PMS0106',
  APPLY_CHECKOUT = 'PMS0107',
  CHECKIN_EDIT = 'PMS0108',
  DIRECT_CHARGEBACK = 'PMS0109',
  URGE_EXTEND_CHECKIN = 'PMS0110',
  CHECKOUT = 'PMS0111',
  SPLIT_ROOM = 'PMS0112',
  RESERVE_ARRANGE = 'PMS0113',
  ROOM_CARDS_MANAGEMENT = 'PMS0114',
  CHECININ_EXCHANGE = 'PMS0115',
  EXTEDN_CHECKIN_DETAIL = 'PMS0116',
  TAKE_CARE = 'PMS0117',
  CHANNEL_DETAIL = 'PMS0118',
  SAVE_PRICE = 'PMS0119',
  // 订单账务页按钮
  SETTLE = 'PMS0120',
  REVERSE_SETTLE = 'PMS0121',
  PRE_SETTLE = 'PMS0122', // 预结算
  ENTER_ACCOUNT = 'PMS0123',
  EXTRA_ROOM_CHARGE = 'PMS0124', // 加收房费
  GOODS = 'PMS0125',
  PRINT_BILL_ORDER = 'PMS0126',
  MAKE_OUT_INVOICE = 'PMS0127', // 开票
  PART_SETTLE = 'PMS0128',
  TRANSTER_ACCOUNT = 'PMS0129',
  PART_REFUND = 'PMS0130',
  BILL_CROSS_NIGHT_AUDIT_REFUND = 'PMS0012', // 订单详情-账单-跨夜审退款按钮权限
  BREW = 'PMS0132', // 冲调
  CONSUME_DETAIL = 'PMS0133',

  // 渠道改价
  BASE_PRICE_EDIT = 'PMS0134',
  BASE_PRICE_EDIT_BATCH = 'PMS0135',
  SPECIAL_PRICE_EDIT = 'PMS0136',
  SPECIAL_PRICE_EDIT_BATCH = 'PMS0137',
  BASE_PRICE_REVERT = 'PMS0158', // 恢复基础房价
  DIFF_PRICE_RULE_EDIT = 'PMS0159', // 价差档

  // 促销管理
  MT_PROMOTION_MANAGEMENT = 'PMS0138',
  XC_PROMOTION_MANAGEMENT = 'PMS0139',
  XC_YOU_XIANG_HUI = 'PMS0140',
  XC_ACTIVITY_SIGN_UP = 'PMS0141',
  DY_PROMOTION_MANAGEMENT = 'PMS0142',

  // 促销规则
  PROMOTION_RULE_DIRECT_EFFCTIVE = 'PMS0143', // PMS集团-统控促销-创建直接生效类规则
  PROMOTION_RULE_STORE_JOIN = 'PMS0144', // PMS集团-统控促销-创建门店报名类

  // 促销编辑
  CONTROL_PROMOTION_EDIT = 'PMS0145', // 集团统控促销编辑
  CONTROL_PROMOTION_BATCH_EDIT = 'PMS0146', // 集团统控促销批量编辑

  // 抖音收款方式
  DY_PAY_WAY = 'PMS0148', // PMS-抖音-收款方式
  STORE_DIRECT_PROMOTION_CREATE = 'PMS0147', // 门店创建直连促销

  // 预夜审
  PRE_NIGHT_AUDIT_SAVE_ROOM_PRICE = 'PMS0150', // 保存房价
  // 手动标记成功
  MANUAL_MARK_SUCCESSFUL = 'PMS0149',

  // 编制审批
  JOB_APPROVAL_SUBMIT_REGION_APPROVE = 'PMS0151', // PMS集团-提交战区审批
  JOB_APPROVAL_REGION_APPROVE_PASS = 'PMS0152', // PMS集团-战区审批通过
  JOB_APPROVAL_REGION_APPROVE_REJECT = 'PMS0153', // PMS集团-战区审批退回
  JOB_APPROVAL_HR_APPROVE_PASS = 'PMS0154', // PMS集团-人事审批通过
  JOB_APPROVAL_HR_APPROVE_REJECT = 'PMS0155', // PMS集团-人事审批退回
  // 订单日志详情
  ORDER_OPERATION_LOG_DETAIL = 'PMS0156',

  // 渠道同步记录详情
  CHANNEL_SYNC_LOG_DETAIL = 'PMS0157',

  // 经营报告-发布权限
  OPERATING_REPORT_RELEASE = 'PMS0160',

  // 员工资料审批  注意集团和门店分开配置
  EMPLOYEE_FILE_SUBMIT_REGION_APPROVAL = 'PMS0161', // PMS门店-员工资料审批-提交区域审批
  EMPLOYEE_FILE_REBACK_APPROVAL = 'PMS0162', // PMS门店-员工资料审批-撤回审批
  EMPLOYEE_FILE_REGION_APPROVAL_PASS = 'PMS0163', // PMS门店-员工资料审批-区域审批通过
  EMPLOYEE_FILE_REGION_APPROVAL_REJECT = 'PMS0164', // PMS门店-员工资料审批-区域审批退回
  EMPLOYEE_FILE_HR_APPROVAL_PASS = 'PMS0165', // PMS门店-员工资料审批-人事审批通过
  EMPLOYEE_FILE_HR_APPROVAL_REJECT = 'PMS0166', // PMS门店-员工资料审批-人事审批退回

  GROUP_EMPLOYEE_FILE_SUBMIT_REGION_APPROVAL = 'PMS0167', // PMS集团-员工资料审批-提交区域审批
  GROUP_EMPLOYEE_FILE_REBACK_APPROVAL = 'PMS0168', // PMS集团-员工资料审批-撤回审批
  GROUP_EMPLOYEE_FILE_REGION_APPROVAL_PASS = 'PMS0169', // PMS集团-员工资料审批-区域审批通过
  GROUP_EMPLOYEE_FILE_REGION_APPROVAL_REJECT = 'PMS0170', // PMS集团-员工资料审批-区域审批退回
  GROUP_EMPLOYEE_FILE_HR_APPROVAL_PASS = 'PMS0171', // PMS集团-员工资料审批-人事审批通过
  GROUP_EMPLOYEE_FILE_HR_APPROVAL_REJECT = 'PMS0172', // PMS集团-员工资料审批-人事审批退回

  // 集团折扣率提醒编辑
  GROUP_DISCOUNT_ALERT_EDIT = 'PMS0173', // PMS集团-折扣率提醒列表-编辑
  GROUP_DISCOUNT_ALERT_BATCH_EDIT = 'PMS0174', // PMS集团-折扣率提醒列表-批量编辑

  // 集团员工上机时长页面tab权限
  GROUP_EMPLOYEE_ONLINE_PLAY_DURATION_TAB = 'PMS0175', // PMS集团-员工上机时长-游戏时长
  GROUP_EMPLOYEE_ONLINE_GATHER_PLAY_DURATION_TAB = 'PMS0176', // PMS集团-员工上机时长-聚玩打卡

  GROUP_DISCOUNT_ALERT_NEW_SHOP_DEFAULT_CONFIG = 'PMS0177', // PMS集团-折扣率提醒-新店默认配置

  // 会员卡购买邀请
  MEMBER_CARD_PURCHASE_INVITATION = 'PMS2170',
}
